import Swiper from "swiper";

import { findControls } from "@plugins";

function initSlider() {
    const gifts = document.querySelector(".js-gifts");

    if (gifts) {
        const sliderContainer = gifts.querySelector(".js-gifts-slider");
        const controls = findControls(gifts, ".js-gifts-controls");

        new Swiper(sliderContainer, {
            slidesPerView: 2,
            spaceBetween: 16,
            pagination: {
                el: controls.pagination,
            },
            navigation: {
                prevEl: controls.buttonPrev,
                nextEl: controls.buttonNext,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                    spaceBetween: 8,
                },
                375: {
                    slidesPerView: 1.5,
                    spaceBetween: 8,
                },
                567: {
                    slidesPerView: 2,
                    spaceBetween: 8,
                },
            },
        });
    }
}
initSlider();
